import { render, staticRenderFns } from "./Reciever.vue?vue&type=template&id=5631b89a&scoped=true"
import script from "./Reciever.vue?vue&type=script&lang=js"
export * from "./Reciever.vue?vue&type=script&lang=js"
import style0 from "./Reciever.vue?vue&type=style&index=0&id=5631b89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631b89a",
  null
  
)

export default component.exports